<template>
  <van-action-sheet v-model:show="isShow" title="确认商品" safe-area-inset-bottom>
    <div class="box" v-if="isShow">
      <div class="boxPad">
        <div class="fvlr goods">
          <div class="imgBox">
            <img :src="goodsInfo.img" />
          </div>
          <div class="fhlu">
            <div class="name">{{ goodsInfo.name }}</div>
            <div class="price" v-if="customerCarId == -1 && goodsInfo.priceTypeFlag === 3 && goodsInfo.loyaltyTypeFlag == 2">
              意向金*：￥ {{ confirmInfo.depositPrice || 0 }}
            </div>
            <div v-else>
              <div class="price" v-if="confirmInfo.id">
                <div v-if="confirmInfo.id != -1">厂商建议零售价* ￥{{ confirmInfo.uniformPrice || 0 }}</div>
                <div v-else>
                  <div style="color:#999">厂商建议零售价* ￥{{ confirmInfo.uniformPrice || 0 }}</div>
                  <div style="text-indent:4em;margin-top:5px">意向金* ￥{{ confirmInfo.depositPrice || 0 }}</div>
                </div>
              </div>
              <div class="price" v-else>厂商建议零售价* ￥{{ goodsInfo.uniformPrice || 0 }}{{ goodsInfo.priceTypeFlag === 2 ? '起' : '' }}</div>
            </div>
          </div>
        </div>
        <div class="padL">
          <CurrentDealer>
            <template #colLabel>参与经销商</template>
          </CurrentDealer>
          <van-field
            v-model="carInfo"
            readonly
            label="选择车辆"
            @click-right-icon="selectCar"
            :right-icon="goodsInfo?.orderSource == 1 ? '' : 'arrow'"
            placeholder="请选择车辆"
          />
        </div>
        <div v-if="goodsInfo.loyaltyTypeFlag == 2 && goodsInfo.priceTypeFlag == 3">
          <BrandSelect :brandInfo="arr" @setbrandInfo="setbrandInfo" />
          <div v-if="arr?.productItem && arr?.productNo && arr?.brand">
            <TyreDetails :productItem="arr?.proItem" />
          </div>
        </div>
        <div class="fvlr bugNum">
          <div>购买数量</div>
          <van-stepper v-model="productNum" :before-change="beforeQuantityChange" min="1" :max="max" button-size="22" />
        </div>
      </div>
      <div class="header" :class="{ top: isLoyalty }">
        温馨提示：支付成功后，实际购买结果以经销商接单为准。
      </div>
      <van-button class="btn" :class="{ top: !isLoyalty }" @click="addShoppingCarFn" :disabled="isChecking" type="primary" block>{{
        isChecking ? '信息校验中...' : '确 定'
      }}</van-button>
    </div>
  </van-action-sheet>
</template>

<script>
import { reactive, toRefs, watch, onMounted } from 'vue'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import { useStore } from 'vuex'
import { Toast } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { getLoyaltyPlanPrice } from '@/api/plan'
import { myCarList } from '@/api/car'
import { addShoppingCar, updateShoppingInf } from '@/api/shoppingCar'
import { onBeforeRouteLeave } from 'vue-router'
import { isNum, getDistance } from '@/util/index'
import { getDealers } from '@/api/plan'
import BrandSelect from '@/components/common/BrandSelect'
import TyreDetails from '@/components/common/TyreDetails'

export default {
  components: {
    BrandSelect,
    TyreDetails,
    CurrentDealer
  },
  emits: ['updateShoppingSuccess'],
  props: ['datas', 'showPopUp', 'currentType', 'from'],
  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()
    let { datas, showPopUp, currentType } = toRefs(props)
    let { currentCarInfo, currentGoodsInfo, dealerInfo, brandInfo } = store.state
    let showType = JSON.parse(sessionStorage.getItem('showType'))
    let isShow = showType ? showType.showPopUp : false
    let sessionCurrentType = showType ? showType.currentType : ''
    let currentTypeVal = sessionCurrentType ? sessionCurrentType : currentType
    const carInfo =
      (currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : '') + ' ' + (currentCarInfo && currentCarInfo.model ? currentCarInfo.model : '')
    const state = reactive({
      isLoyalty: false,
      customerCarId: currentCarInfo?.id,
      arr: brandInfo,
      brandInfo: brandInfo,
      isShow,
      datas,
      currentType,
      currentTypeVal: currentTypeVal,
      goodsInfo: currentGoodsInfo,
      dealerInfo,
      showPopUp,
      carInfo: carInfo.trim(),
      productNum: 1,
      max: 0,
      confirmInfo: {},
      hasCheckPrice: false,
      isChecking: false,
      errMsg: ''
    })
    onBeforeRouteLeave(to => {
      //临时补丁 离开页面时 如果是非选择车型页面  就清空目前已选择的意向金选项 目的：打开其他商城可展示默认车型
      if (to.name != 'carList' && currentCarInfo && currentCarInfo.intention) {
        store.dispatch('setCurrentCarInfo', {})
        store.dispatch('', {})
      }
      state.isShow = false
    })
    const getPrice = async () => {
      let { id, intention, baumuster } = store.state.currentCarInfo
      let { currentGoodsInfo } = store.state
      if (!store.state.currentCarInfo) return
      if (currentGoodsInfo.loyaltyTypeFlag == 2 && currentGoodsInfo.priceTypeFlag == 3 && id && !state.arr?.productNo) {
        return
      }
      if (intention) {
        state.confirmInfo = {
          id: -1,
          intention: intention,
          uniformPrice: currentGoodsInfo.uniformPrice,
          depositPrice: currentGoodsInfo.depositPrice,
          buyNum: state.productNum
        }
        state.max = state.datas.buyAmountLimit
        return
      }
      let params = {
        loyaltyId: store.state.currentGoodsInfo.loyaltyId,
        baumuster: baumuster,
        gsCode: store.state.dealerInfo.gs_code || store.state.dealerInfo.gsCode,
        buyNum: state.productNum,
        carId: id,
        orderSource: store.state.currentGoodsInfo.orderSource || 0,
        qrcodeHistoryId: store.state.currentGoodsInfo.qrcodeHistoryId || '',
        productNo: state.arr?.proItem?.productNo || '',
        menuBaumuster: state.arr?.proItem?.baumuster || '',
        finStart: state.arr?.proItem?.finStart || '',
        finEnd: state.arr?.proItem?.finEnd || '',
        productTypeFlag: state.arr?.proItem?.partType || ''
      }
      // let oneParam = sessionStorage.getItem('getPrice') === JSON.stringify(params)
      // if (oneParam) return
      sessionStorage.setItem('getPrice', JSON.stringify(params)) // app.vue 删除（切换路由）
      if (!params.baumuster || !params.gsCode || !params.loyaltyId) return
      state.isChecking = true
      state.isLoyalty = true
      try {
        let data = await getLoyaltyPlanPrice(params)
        const isTyrePack =  state.goodsInfo.productType == 1 && state.goodsInfo.loyaltyTypeFlag==2
        // 权益用完前是否允许继续购买
        const canContinueBuyingBeforeUseUp = data.buyStatusFlag === 0
        // 轮胎情况java单独增强了buyAmountLimit字段，此字段可以cover- buyStatusFlag控制，所以这里仅保留非轮胎包情况的逻辑
        if(!isTyrePack) {
          data.buyAmountLimit = canContinueBuyingBeforeUseUp ? data.buyAmountLimit : 1
        }
        state.max = data.buyAmountLimit
        state.confirmInfo = data
        // 保存商品告知书格式数据
        store.commit('SETCURRENTNOTIFICATIONDATA', {
          year: '2023',
          day: '13',
          effectiveMonth: '72',
          fin: 'LE42050421L379494',
          month: '03',
          // notificationFile: data.notificationFile,
          // notificationName: data.notificationFileTitle
          notificationFile: [
            'https://plpomcninfstaccblob031.blob.core.chinacloudapi.cn/staticdata/category/2022-12-01/5d66c469-11bb-4c25-89b8-2a020c5118c0.原厂保养套餐（新版）2A2B_AMG.png'
          ],
          notificationName: '梅赛德斯-奔驰原厂保养套餐(新版）客户告知书  2A2B_AMG机油'
        })

        if (state.productNum > data.buyAmountLimit) {
          state.productNum = 1
        }
        state.hasCheckPrice = true
        state.isChecking = false
      } catch (e) {
        let { statusCode, message } = e
        if (statusCode === 888 || statusCode >= 606 || statusCode >= 616) {
          message && toastFn(message)
          state.errMsg = message
        }
        state.hasCheckPrice = false
        state.isChecking = false
      }
    }
    const setbrandInfo = val => {
      state.arr = val
    }
    const getDealerDistanceFn = async params => {
      try {
        let { list = [] } = await getDealers(params)
        let dealer = list && list.length === 1 ? list[0] : {}
        dealer.distance = getDistance(dealer.distance)
        let _gsCode = dealer.gs_code || dealer.gsCode
        dealer.gs_code = dealer.gsCode = _gsCode
        return dealer
      } catch (e) {
        return {}
      }
    }
    const getDealerInfoByGscode = async dealerInfo => {
      let { lat, lng } = store.state.position
      let { currentGoodsInfo, shoppingCartDealerObj } = store.state
      // console.log('getDealerInfoByGscode--statr', currentGoodsInfo, dealerInfo, shoppingCartDealerObj)
      let gsCode = dealerInfo.gs_code || dealerInfo.gsCode
      let loyaltyId = currentGoodsInfo.id
      let label = `${gsCode}_${loyaltyId}_loyalty`
      if (shoppingCartDealerObj[label]) {
        store.commit('SETDEARINFO', shoppingCartDealerObj[label])
        return
      }
      try {
        let params = { loyaltyId, gsCode, latitude: lat, longitude: lng }
        let dealer = await getDealerDistanceFn(params)
        dealer = dealer.gsCode ? dealer : dealerInfo
        if (!dealer.gsCode && !dealer.gs_code) {
          return
        }
        setTimeout(() => {
          store.commit('SETDEARINFO', dealer)
          store.commit('SETSHOPPINGCARTDEALEROBJ', {
            ...shoppingCartDealerObj,
            [label]: dealer
          })
        }, 0)
      } catch (error) {
        console.log(error)
      }
    }
    watch(
      () => state.arr,
      n => {
        if (n?.proItem) {
          getPrice()
        }
      },
      { deep: true }
    )
    watch(
      () => state.showPopUp,
      () => {
        let { currentCarInfo, currentGoodsInfo, dealerInfo, brandInfo } = store.state // 更新数据
        state.arr = brandInfo
        console.log('state.currentTypeVal', state.currentTypeVal)
        // if(state.currentTypeVal=='shoppingCar'){
        state.confirmInfo = currentGoodsInfo
        // }
        if (currentCarInfo && currentCarInfo.id == -1) {
          currentCarInfo.intention = true
        }
        //  if(state.arr?.productItem){
        getPrice()
        // }
        state.isShow = true
        state.currentTypeVal = state.currentType
        state.goodsInfo = currentGoodsInfo
        state.dealerInfo = dealerInfo
        if (dealerInfo && Reflect.has(dealerInfo, 'joinPlanFlag')) {
          store.dispatch('setDealerJoinPlanFlag', !!dealerInfo.joinPlanFlag)
        }
        if (currentCarInfo?.intention) {
          state.carInfo = '暂不选择车辆'
        } else {
          const carInfo =
            (currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : '') + ' ' + (currentCarInfo && currentCarInfo.model ? currentCarInfo.model : '')
          state.carInfo = carInfo.trim()
        }
        if (!currentCarInfo.id) {
          state.carInfo = '暂不选择车辆'
        }
        state.productNum = (state.datas && state.datas.num) || 1
        if (state.currentTypeVal === 'shoppingCar') {
          // 购物车弹窗-刷新距离
          getDealerInfoByGscode(dealerInfo)
        }
      }
    )
    watch(
      () => store.state.dealerInfo,
      n => {
        state.isShow && getPrice()
        if (n && Reflect.has(n, 'joinPlanFlag')) {
          store.dispatch('setDealerJoinPlanFlag', !!n.joinPlanFlag)
        }
      }
    )
    watch(
      () => store.state.currentCarInfo,
      currentCarInfo => {
        if (state.isShow && currentCarInfo) {
          if (currentCarInfo?.intention) {
            state.carInfo = '暂不选择车辆'
          } else {
            const carInfo =
              (currentCarInfo && currentCarInfo.plate ? currentCarInfo.plate : '') + ' ' + (currentCarInfo && currentCarInfo.model ? currentCarInfo.model : '')
            state.carInfo = carInfo.trim()
          }
        }
      }
    )
    watch(
      () => state.productNum,
      n => {
        // console.log(n, state.max);
        if (n === state.max) {
          toastFn(`商品加购件数已达到最大购买量${n}件`)
        }
      }
    )
    watch(
      () => store.state.brandInfo,
      n => {
        state.brandInfo = n
        state.arr = n
      }
    )
    watch(
      () => store.state.currentGoodsInfo,
      n => {
        state.goodsInfo = n
      }
    )
    const selectCar = () => {
      // if(state.goodsInfo?.loyaltyType==2) return false
      sessionStorage.setItem(
        'showType',
        JSON.stringify({
          showPopUp: true,
          currentType: state.currentTypeVal
        })
      )
      let loyaltyId = store.state.currentGoodsInfo.loyaltyId
      router.push({ path: '/carList', query: { loyaltyId, callBack: true, event: '切换车辆' } })
    }
    function toastFn(msg) {
      Toast({ message: msg, position: 'bottom' })
    }
    const addShoppingCarFn = async () => {
      let { dealerInfo, currentCarInfo } = store.state
      let msg = ''
      if (!dealerInfo.gs_code && !dealerInfo.gsCode) {
        msg = '请选择经销商'
        toastFn(msg)
        return
      }
      if (!(store.state.dealerJoinPlanFlag || state.dealerInfo.joinPlanFlag)) {
        msg = '请选参加活动的经销商'
        toastFn(msg)
        return
      }
      if (!currentCarInfo || !currentCarInfo.model) {
        if (!currentCarInfo?.intention && currentCarInfo?.id) {
          //新增暂不选择车辆 不校验
          msg = '请选择车辆'
          toastFn(msg)
          return
        }
      }
      if (state.goodsInfo?.loyaltyTypeFlag == 2 && state.goodsInfo?.priceTypeFlag == 3 && currentCarInfo?.id != -1) {
        if (!state.arr?.brand && currentCarInfo?.id) {
          msg = '请选择产品品牌'
          toastFn(msg)
          return
        }
        if (!state.arr?.spec && currentCarInfo?.id) {
          msg = '请选择产品规格'
          toastFn(msg)
          return
        }
        if (!state.arr?.productItem && currentCarInfo?.id) {
          msg = '请选择产品编号'
          toastFn(msg)
          return
        }
      }
      // if (!state.max) {
      //   msg = "商品加购件数已达到最大购买量";
      //   toastFn(msg);
      //   return;
      // }
      if (!state.hasCheckPrice && state.goodsInfo?.orderSource != 1) {
        if (!currentCarInfo?.intention) {
          //新增暂不选择车辆 不校验
          // state.errMsg && toastFn(state.errMsg)
          toastFn(state.errMsg || '请选择车辆')
          return
        }
      }
      if (state.currentTypeVal === 'bugNow') {
        let { img, name, productType, loyaltyId, boUserId } = state.goodsInfo
        let { uniformPrice, selfPrice } = state.confirmInfo
        let depositPrice = state.datas.depositPrice
        let intention = currentCarInfo?.intention
        let data = {
          imgSrc: img,
          productName: name,
          dealerName: dealerInfo.name,
          carInf: state.carInfo,
          price: uniformPrice,
          num: state.productNum,
          dealerInfo,
          loyaltyId,
          boUserId,
          customerCarId: currentCarInfo.id,
          intention,
          gsCode: dealerInfo.gs_code || dealerInfo.gsCode || '',
          productType,
          payTypeFlag: state.datas.payTypeFlag, //支付方式
          depositPrice: depositPrice, //意向金价格
          selfPrice: isNum(selfPrice) ? selfPrice : uniformPrice,
          carInfoObj: currentCarInfo,
          brand: state.arr?.brand,
          spec: state.arr?.spec,
          productNo: state.arr?.proItem?.productNo || '',
          menuBaumuster: state.arr?.proItem?.baumuster || '',
          baumuster: state.arr?.proItem?.baumuster || '',
          finStart: state.arr?.proItem?.finStart || '',
          finEnd: state.arr?.proItem?.finEnd || '',
          productTypeFlag: state.arr?.proItem?.partType || ''
        }
        store.dispatch('setCurrentBuyProductInfo', data)
        router.push({
          path: '/confirmOrder',
          query: {
            from: 'commodityDetails',
            event: '致友计划下单'
          }
        })
      } else if (state.currentTypeVal === 'shoppingCar') {
        // 购物车修改参数
        let { productType, loyaltyId, shoppingCarDetailId } = store.state.currentGoodsInfo
        let params = {
          customerCarId: currentCarInfo.id, //车辆编号
          delStatusFlag: 0, //删除状态
          gsCode: dealerInfo.gs_code || dealerInfo.gsCode || '', //经销商code
          productId: loyaltyId, //商品编号
          productQuantity: state.productNum, //购买商品数量
          productType: productType, //购买商品类型{1:计划2:轮胎}
          id: shoppingCarDetailId, //购物车明细编号
          payTypeFlag: currentCarInfo?.intention ? 3 : 2, //2:定金 3:意向金,
          brand: state.arr?.brand,
          spec: state.arr?.spec,
          productNo: state.arr?.proItem?.productNo || '',
          menuBaumuster: state.arr?.proItem?.baumuster || '',
          baumuster: state.arr?.proItem?.baumuster || '',
          finStart: state.arr?.proItem?.finStart || '',
          finEnd: state.arr?.proItem?.finEnd || '',
          productTypeFlag: state.arr?.proItem?.partType || ''
        }
        // console.log(params)
        try {
          await updateShoppingInf(params)
          emit('updateShoppingSuccess')
          state.isShow = false
        } catch (e) {
          toastFn(e.message || '购物车信息更新失败')
        }
      } else {
        // 加入购物车
        let { productType } = store.state.currentGoodsInfo
        let params = {
          customerCarId: currentCarInfo.id, //车辆编号
          delStatusFlag: 0, //删除状态
          gsCode: dealerInfo.gs_code || dealerInfo.gsCode || '', ///经销商code
          productId: state.goodsInfo.loyaltyId, //商品编号
          productQuantity: state.productNum, //购买商品数量
          // productType:loyaltyType==2 ? '4' : productType, //购买商品类型{1:计划2:轮胎}
          productType,
          payTypeFlag: currentCarInfo?.intention ? 3 : 2, //2:定金 3:意向金
          brand: state.arr?.brand,
          spec: state.arr?.spec,
          productNo: state.arr?.proItem?.productNo || '',
          menuBaumuster: state.arr?.proItem?.baumuster || '',
          baumuster: state.arr?.proItem?.baumuster || '',
          finStart: state.arr?.proItem?.finStart || '',
          finEnd: state.arr?.proItem?.finEnd || '',
          productTypeFlag: state.arr?.proItem?.partType || ''
        }
        try {
          const { productId } = await addShoppingCar(params)
          console.log(productId)
          if (productId) {
            toastFn('加入购物车成功')
            state.isShow = false
          }
          store.dispatch('getCountOfShoppingCar')
        } catch (e) {
          toastFn(e.message || '加入购物车失败')
        }
      }
    }

    onMounted(async () => {
      sessionStorage.removeItem('showType') // 删除显示popUp标志
      if (isShow) {
        if (state.arr?.productItem) {
          getPrice()
        }
      }
      state.errMsg = ''
      if (currentCarInfo?.intention) {
        state.carInfo = '暂不选择车辆'
        return
      }
      if (currentCarInfo && currentCarInfo.id) {
        return
      }
      let { list } = await myCarList()
      let defaultInfo = list.length && list.filter(item => item.defaultFlag)[0]
      store.dispatch('setCurrentCarInfo', defaultInfo)
      state.carInfo = (defaultInfo && defaultInfo.plate) || ''
    })

    const beforeQuantityChange = () => {
      const isLoyalty = state.goodsInfo.productType == 1
      return new Promise((resolve) => {
        if(isLoyalty) {
          toastFn('单店单次只能购买一件，如果想购买多件请分次购买')
          return resolve(false)
        }
        else {
          resolve(true)
        }
      });
    }

    return {
      ...toRefs(state),
      setbrandInfo,
      toastFn,
      selectCar,
      addShoppingCarFn,
      beforeQuantityChange
    }
  }
}
</script>

<style lang="scss" scoped>
.padL {
  padding-left: 15px;
}
.boxPad {
  padding-top: 20px;
  padding-right: 15px;
}
.box {
  padding-bottom: 50px;
  padding-left: 0;
  .van-cell {
    padding: 13px 0;
    border-style: solid;
    border-color: rgba(204, 204, 204, 0.5);
    border-width: 0.5px 0;
  }
  :deep(.van-field__label) {
    color: #333;
    font-weight: bold;
    margin-right: 0;
  }
  :deep(.van-field__control:disabled) {
    color: #333;
  }
}
.van-field__label {
  width: 6em;
}
.goods {
  height: 72px;
  font-size: 14px;
  color: #333333;
  padding-left: 15px;
  padding-bottom: 20px;
  border-bottom: solid 1px #cccccc;
  margin-bottom: 16px;
}
.price {
  font-size: 14px;
  font-weight: 600;
  color: #3088c5;
  margin-top: 8px;
}
.imgBox {
  width: 96px;
  height: 72px;
  margin: 0 11px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.fhlu {
  width: 100%;
  height: 100%;
}
.bugNum {
  padding: 13px 15px;
  overflow: auto;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);
}
.btn {
  width: 100%;
}
.top {
  margin-top: 25px;
}
.header {
  height: 24px;
  color: #fff;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background-color: orange;
}
</style>
